import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, ShieldCheck } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-22">
          {/* Company Info */}
          <div data-id="element-23">
            <div className="mb-6" data-id="element-24">
              <h3 className="text-2xl font-bold text-white mb-1" data-id="element-25">LISSOWSKI</h3>
              <p className="text-gray-400 text-sm" data-id="element-26">
                Glas- & Gebäudereinigung GmbH
              </p>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-27">
              Ihr zuverlässiger Partner für professionelle Gebäudereinigung in
              Aachen und Umgebung. Seit über 50 Jahren genial gereinigt.
            </p>
            <div className="flex items-center space-x-2 text-emerald-400" data-id="element-28">
              <ShieldCheck className="w-5 h-5" data-id="element-29" />
              <span className="font-medium" data-id="element-30">Meisterbetrieb</span>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-31">
            <h4 className="text-lg font-bold text-white mb-6" data-id="element-32">Kontakt</h4>
            <ul className="space-y-4" data-id="element-33">
              <li className="flex items-start" data-id="element-34">
                <MapPin className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-35" />
                <span className="text-gray-300" data-id="element-36">
                  Jülicher Straße 126
                  <br data-id="element-37" />
                  52070 Aachen
                </span>
              </li>
              <li className="flex items-center" data-id="element-38">
                <Phone className="w-5 h-5 text-emerald-500 mr-3 flex-shrink-0" data-id="element-39" />
                <a href="tel:0241512746" className="text-gray-300 hover:text-white transition-colors" data-id="element-40">
                  0241 512746
                </a>
              </li>
              <li className="flex items-center" data-id="element-41">
                <Mail className="w-5 h-5 text-emerald-500 mr-3 flex-shrink-0" data-id="element-42" />
                <a href="mailto:buero@lissowski-gmbh.de" className="text-gray-300 hover:text-white transition-colors" data-id="element-43">
                  buero@lissowski-gmbh.de
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-44">
            <h4 className="text-lg font-bold text-white mb-6" data-id="element-45">
              Öffnungszeiten
            </h4>
            <ul className="space-y-3" data-id="element-46">
              <li className="flex justify-between text-gray-300 border-b border-gray-800 pb-2" data-id="element-47">
                <span data-id="element-48">Mo - Do</span>
                <span data-id="element-49">8:00 - 14:00</span>
              </li>
              <li className="flex justify-between text-gray-300 border-b border-gray-800 pb-2" data-id="element-50">
                <span data-id="element-51">Freitag</span>
                <span data-id="element-52">8:00 - 12:00</span>
              </li>
            </ul>
            <div className="mt-6 flex items-start p-3 bg-blue-900/30 rounded-lg border border-blue-900" data-id="element-53">
              <Clock className="w-5 h-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-54" />
              <p className="text-sm text-gray-300" data-id="element-55">
                <span className="text-white font-medium block mb-1" data-id="element-56">
                  24h Notdienst
                </span>
                Für Not- und Ausnahmefälle sind wir rund um die Uhr erreichbar.
              </p>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-57">
            <h4 className="text-lg font-bold text-white mb-6" data-id="element-58">Links</h4>
            <ul className="space-y-3" data-id="element-59">
              <li data-id="element-60">
                <Link to="/leistungen" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-61">
                  Unsere Leistungen
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/cleancopter" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-63">
                  CleanCopter Innovation
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/karriere" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-65">
                  Karriere & Ausbildung
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/ueber-uns" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-67">
                  Über uns
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/impressum" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-69">
                  Impressum & Datenschutz
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-70">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-71">
            © {currentYear} Lissowski Glas- und Gebäudereinigung GmbH. Alle
            Rechte vorbehalten.
          </p>
          <div className="flex space-x-6" data-id="element-72">
            <Link to="/impressum" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-73">
              Impressum
            </Link>
            <Link to="/impressum" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-74">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}